var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5531 4.95576L3.91313 14.0718C2.2998 14.7198 2.30913 15.6198 3.61713 16.0211L9.68647 17.9144L23.7291 9.05443C24.3931 8.65043 24.9998 8.86776 24.5011 9.31043L13.1238 19.5784H13.1211L13.1238 19.5798L12.7051 25.8358C13.3185 25.8358 13.5891 25.5544 13.9331 25.2224L16.8811 22.3558L23.0131 26.8851C24.1438 27.5078 24.9558 27.1878 25.2371 25.8384L29.2625 6.86776C29.6745 5.21576 28.6318 4.46776 27.5531 4.95576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.21457e7eb8570791449e5c9d73a3d91a.svg";
export { ForwardRef as ReactComponent };